import { render, staticRenderFns } from "./contribute.vue?vue&type=template&id=d18616dc&scoped=true&"
import script from "./contribute.vue?vue&type=script&lang=js&"
export * from "./contribute.vue?vue&type=script&lang=js&"
import style0 from "./contribute.vue?vue&type=style&index=0&id=d18616dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18616dc",
  null
  
)

export default component.exports